import {css} from 'lit'; export default css`:host{background-color:var(--goto-background-color-default);display:flex}`;
    